/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
import React, {useEffect, useRef, useState} from 'react';
import * as PIXI from 'pixi.js';
import '@pixi/unsafe-eval';
import {useTick, AnimatedSprite} from '@pixi/react';

interface SmokeProps {
  onAnimationComplete: () => void;
  stageWidth: number;
  stageHeight: number;
  scaleUpValue: number;
  firstAnimation: PIXI.Texture[];
  fullScreenAnimation: PIXI.Texture[];
  senderPosition: number;
  receiverPosition: number;
  canvasPosition: any;
  playerIconCenterPositions: any;
  isMuted: boolean;
}

const Smoke = React.memo((props: SmokeProps) => {
  const {
    stageWidth,
    stageHeight,
    onAnimationComplete,
    scaleUpValue,
    firstAnimation,
    senderPosition,
    receiverPosition,
    canvasPosition,
    playerIconCenterPositions,
    fullScreenAnimation,
    isMuted,
  } = props;

  // TODO
  const startPosition = {
    y: playerIconCenterPositions[senderPosition]?.y - canvasPosition?.top,
    x: playerIconCenterPositions[senderPosition]?.x - canvasPosition?.left,
  };
  const endPosition = {
    y: playerIconCenterPositions[receiverPosition]?.y - canvasPosition?.top,
    x: playerIconCenterPositions[receiverPosition]?.x - canvasPosition?.left,
  };
  // TODO remember to deduct it
  const initialPoint: [number, number] = [startPosition?.x, startPosition?.y];
  const targetPoint: [number, number] = [endPosition?.x, endPosition?.y];

  const [spritePosition, setSpritePosition] = useState({
    x: initialPoint[0],
    y: initialPoint[1],
  });
  const [elapsedTime, setElapsedTime] = useState<number>(0);
  const [shouldAnimationBeMirrored, setShouldAnimationBeMirrored] = useState<boolean>(false);
  const [currentAnimation, setCurrentAnimation] = useState<number>(1);

  const audioContextRef = useRef<AudioContext | null>(null);
  const audioBufferRef = useRef<AudioBuffer | null>(null);
  const audioSourceRef = useRef<AudioBufferSourceNode | null>(null);

  const audioFile = '/audio/sticker/lighter.mp3';

  useEffect(() => {
    const loadAudio = async () => {
      const audioContext = new AudioContext();
      const response = await fetch(audioFile);
      const audioData = await response.arrayBuffer();
      const audioBuffer = await audioContext.decodeAudioData(audioData);

      audioContextRef.current = audioContext;
      audioBufferRef.current = audioBuffer;
    };

    loadAudio();

    return () => {
      if (audioSourceRef.current) {
        audioSourceRef.current.stop();
      }
      if (audioContextRef.current) {
        audioContextRef.current.close();
      }
    };
  }, []);

  useTick(delta => {
    console.log(' *** useTick in Smoke *** ');
    if (firstAnimation.length !== 0) {
      if (currentAnimation === 1) {
        if (initialPoint[0] <= stageWidth / 2) {
          setShouldAnimationBeMirrored(true);
        }
        if (
          !audioSourceRef.current &&
          audioContextRef.current &&
          audioBufferRef.current &&
          !isMuted
        ) {
          const audioContext = audioContextRef.current;
          const audioBuffer = audioBufferRef.current;

          const audioSource = audioContext.createBufferSource();
          audioSource.buffer = audioBuffer;
          audioSource.connect(audioContext.destination);
          audioSource.start();

          audioSourceRef.current = audioSource;
        }
        setElapsedTime(prevElapsedTime => prevElapsedTime + delta);
        setSpritePosition({x: initialPoint[0], y: initialPoint[1]});
        if (elapsedTime >= firstAnimation.length) {
          setCurrentAnimation(2);
          setElapsedTime(0);
        }
      } else if (currentAnimation === 2) {
        // TODO set animation time
        setElapsedTime(prevElapsedTime => prevElapsedTime + delta);
        setSpritePosition({x: initialPoint[0], y: initialPoint[1]});
        if (elapsedTime >= fullScreenAnimation.length) {
          onAnimationComplete();
        }
      }
    }
  });

  //! otherwise type error
  if (
    firstAnimation.length === 0 ||
    elapsedTime === 0 ||
    (spritePosition.x === 0 && spritePosition.y === 0) ||
    (spritePosition.x === null && spritePosition.y === null)
  ) {
    return null;
  }
  return (
    <AnimatedSprite
      animationSpeed={1}
      textures={currentAnimation === 1 ? firstAnimation : fullScreenAnimation}
      anchor={currentAnimation === 1 ? [1, 0.8] : 0.5}
      x={currentAnimation === 1 ? spritePosition.x : stageWidth / 2}
      y={currentAnimation === 1 ? spritePosition.y : stageHeight / 2}
      isPlaying
      loop={false}
      scale={
        currentAnimation === 1
          ? {
              x: shouldAnimationBeMirrored ? -0.5 * scaleUpValue : 0.5 * scaleUpValue,
              y: 0.5 * scaleUpValue,
            }
          : 2.5
      }
    />
  );
});

Smoke.displayName = 'Smoke';

export default Smoke;
